import { postConstants } from '../constants';

export function posts(state = {}, action) {
  switch (action.type) {
    case postConstants.GETALL_REQUEST:
      return {
        state,
        loading: true
      }
    case postConstants.GETALL_SUCCESS:
      return {
        ...state,
        items: action.items,
        total: action.total,
        loading: false
      }
    case postConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    default:
      return state;
  }
}

export function AddPost(state = {}, action) {
  switch (action.type) {
    case postConstants.ADD_REQUEST:
      return {
        state,
        loading: true,
      }
    case postConstants.ADD_SUCCESS:
      return {
        ...state,
        status: action.status,
        loading: false
      }
    case postConstants.ADD_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        status: false
      };
    default:
      return state;
  }
}

export function GetPost(state = {}, action) {
  switch (action.type) {
    case postConstants.GET_REQUEST:
      return {
        state,
        loading: true,
      }
    case postConstants.GET_SUCCESS:
      return {
        ...state,
        item: action.item,
        loading: false
      }
    case postConstants.GET_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function UpdatePost(state = {}, action) {
  switch (action.type) {
    case postConstants.UPDATE_REQUEST:
      return {
        state,
        loading: true,
      }
    case postConstants.UPDATE_SUCCESS:
      return {
        ...state,
        status: action.status,
        loading: false
      }
    case postConstants.UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        status: false
      };
    default:
      return state;
  }
}